var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomatedAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 74,
    viewBox: "0 0 66 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5068_10727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0714 0C21.6395 0 23.7143 2.0668 23.7143 4.625V9.25H42.2857V4.625C42.2857 2.0668 44.3605 0 46.9286 0C49.4967 0 51.5714 2.0668 51.5714 4.625V9.25H58.5357C62.3806 9.25 65.5 12.3574 65.5 16.1875V23.125H0.5V16.1875C0.5 12.3574 3.61942 9.25 7.46429 9.25H14.4286V4.625C14.4286 2.0668 16.5033 0 19.0714 0ZM0.5 27.75H65.5V67.0625C65.5 70.8926 62.3806 74 58.5357 74H7.46429C3.61942 74 0.5 70.8926 0.5 67.0625V27.75ZM12.1071 37C10.8304 37 9.78571 38.0406 9.78571 39.3125V48.5625C9.78571 49.8344 10.8304 50.875 12.1071 50.875H53.8929C55.1696 50.875 56.2143 49.8344 56.2143 48.5625V39.3125C56.2143 38.0406 55.1696 37 53.8929 37H12.1071Z",
    fill: "#352750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5068_10727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 74,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedAppointment);
export default __webpack_public_path__ + "static/media/Automated_appointment.692355a818ee2facc083d67ee8df11e2.svg";
export { ForwardRef as ReactComponent };